import {Route} from '@react-navigation/native';
import React from 'react';

export enum Screens {
  Main = 'main',
  MainTabs = 'mainTabs',
  DrawerMenu = 'drawerMenu',
  BottomTabsMenu = 'bottomTabsMenu',
  LoginScreens = 'loginScreens',
  Login = 'login',
  LoginConfirmation = 'loginConfirmation',
  ProfileConfirmation = 'profileConfirmation',
  PinCodeAuthentication = 'pinCodeAuthentication',
  ChangeCityMobile = 'changeCityMobile',
  Profile = 'profile',
  CardServicesMenu = 'cardServicesMenu',
  CardServices = 'cardServices',
  TransportService = 'transportService',
  TransportCardReplenishmentHistory = 'transportCardReplenishmentHistory',
  BankingService = 'bankingService',
  PrivilegesService = 'privilegesService',
  PrivilegesServiceDetails = 'privilegesServiceDetails',
  LoyaltyProgram = 'loyaltyProgram',
  LoyaltyProgramAcceptor = 'loyaltyProgramAcceptor',
  VolunteersService = 'volunteersService',
  VolunteersServiceEvents = 'volunteersServiceEvents',
  VolunteersServiceExchangeHistory = 'volunteersServiceExchangeHistory',
  AcceptorsFilter = 'acceptorsFilter',
  SupportServiceTab = 'supportServiceTab',
  SupportService = 'supportService',
  SupportServiceTopics = 'supportServiceTopics',
  SupportServiceTopic = 'supportServiceTopic',
  SupportServiceCreateTopic = 'supportServiceCreateTopic',
  PollsMenu = 'pollsMenu',
  Polls = 'polls',
  PollsTypeSurvey = 'pollsTypeSurvey',
  PollsTypeVote = 'pollsTypeVote',
  PollsTypeSurveyForm = 'pollsTypeSurveyForm',
  PollsTypeSurveyResult = 'pollsTypeSurveyResult',
  PollsTypeVoteForm = 'pollsTypeVoteForm',
  PollsTypeVoteResult = 'pollsTypeVoteResult',
  VisuallyImpairedSettings = 'visuallyImpairedSettings',
  AboutApplication = 'aboutApplication',

  QrCodeCard = 'qrCodeCard',

  SocialSupportMeasuresMenu = 'socialSupportMeasuresMenu',
  SocialSupportMeasures = 'socialSupportMeasures',
  StateAssignments = 'stateAssignments',
  StatePrograms = 'statePrograms',
  ExpenseLiabilities = 'expenseLiabilities',

  ProfileMenu = 'profileMenu',
  ProfileBaseInfo = 'profileBaseInfo',
  ProfileNotificationSettings = 'profileNotificationSettings',
  ProfileUserDocuments = 'profileDocuments',
  ProfileUserContacts = 'profileContacts',
  ProfileUserPhoneConfirmation = 'profileUserPhoneConfirmation',
  ProfileUserEmailConfirmation = 'profileUserEmailConfirmation',
  ProfileSafety = 'profileSafety',
  ProfileChangePassword = 'profileChangePassword',
  ProfileApplications = 'profileApplications',
  ProfileApplicationsFilter = 'profileApplicationsFilter',
  ProfileApplicationsItem = 'profileApplicationsItem',

  NotificationsMenu = 'notificationsMenu',
  Notifications = 'notifications',
  NotificationsItem = 'notificationsItem',

  MainNotificationsItem = 'mainNotificationsItem',

  DesktopProfileMe = 'desktopProfileMe',
  DesktopProfileSettings = 'desktopProfileSettings',

  WebView = 'webview',
  News = 'news',
  NewsArticle = 'newsArticle',
}

export enum Routes {
  main = '/home/:tab?/:id?',
  mainMobile = '/home',
  login = '/login',
  confirmation = '/confirmation',
  loginConfirmation = '/login-confirmation',
  profileConfirmation = '/profile-confirmation',
  profile = '/profile',
  changeCityMobile = '/change-city',
  cardService = '/card-services',
  transportService = '/card-services/transport',
  transportCardReplenishmentHistory = '/card-services/transport/replenishment-history',
  bankingService = '/card-services/banking',
  privilegesService = '/card-services/privileges',
  privilegesServiceDetails = '/card-services/privileges/:ssmCode',
  supportService = '/support-service',
  loyaltyProgram = '/card-services/loyalty-program',
  loyaltyProgramAcceptor = '/card-services/loyalty-program/acceptor/:id',
  volunteersService = '/card-services/volunteers',
  volunteersServiceEvents = '/card-services/volunteers/events',
  volunteersServiceExchangeHistory = '/card-services/volunteers/history',
  acceptorsFilter = '/acceptors-filter',

  polls = '/polls',
  pollsTypeSurvey = '/polls/type-survey',
  pollsTypeVote = '/polls/type-vote',
  pollsTypeSurveyForm = '/polls/type-survey/:pollId',
  pollsTypeVoteForm = '/polls/type-vote/:pollId',

  visuallyImpairedSettings = '/visually-impaired-settings',
  aboutApplication = '/about-application',
  qrCodeCard = '/qr-code-card',

  socialSupportMeasures = '/social-support-measures',
  stateAssignments = '/social-support-measures/state-assignments',
  statePrograms = '/social-support-measures/state-programs',
  expenseLiabilities = '/social-support-measures/expense-liabilities',

  profileMenu = '/profile/menu',
  profileBaseInfo = '/profile/baseInfo',
  profileNotificationSettings = '/profile/notification-settings',
  profileUserDocuments = '/profile/documents',
  profileUserContacts = '/profile/contacts',
  profileUserPhoneConfirmation = '/profile/phone-confirmation',
  profileUserEmailConfirmation = '/profile/email-confirmation',
  profileChangePassword = '/profile/settings/change-password',

  mobileNotifications = '/notifications',
  desktopNotifications = '/notifications/:id?',
  notificationsItem = '/notifications/:id',
  mainNotificationsItem = '/home/notifications/:id',

  supportServiceTopicsDesktop = '/support-service/topics/:id?',
  supportServiceTopics = '/support-service/topics',
  supportServiceCreateTopic = '/support-service/topics/new',
  supportServiceTopic = '/support-service/topics/:id',

  profileApplications = '/profile/applications/:application-id?',
  profileApplicationsFilter = '/profile/applications-filter',
  profileApplicationsItem = '/profile/applications/:application-id',

  profileMe = '/profile/me',
  profileSettings = '/profile/settings/:modal?',
  profileSafety = '/profile/safety',

  webView = '/webview',

  drawer = '/drawer',
  news = '/news',
  newsArticle = '/news/:id',
  mainNewsArticle = '/main/news/:id',
}

export interface TabBarIconProps {
  focused: boolean;
  color: string;
  size: number;
  Icon: React.FC<{color: string; width?: number; height?: number}>;
  webRoute: Routes;
  routeName: Screens;
}

export interface NavigationRouteProps<T extends Object> extends Route<string> {
  params: T;
}
